<template>
  <div>
    <AppModal
      v-show="modalToggle"
      @modalSignCancel="modalSignCancel"
      @modalSignCheck="modalSignCheck"
    />
    <header id='header'>
      <div class='inner'>
        <div class='col col1'>
          <a class='btnNavi prev'>
            <span @click.stop.prevent="backBtn" class='ico'>이전</span>
          </a>
        </div>
        <div class='col col2'>
        <!-- 마이페이지, 주문내역 -->
          <h1>{{$t(`${'MyPage.orderHistory'}`)}}</h1>
        </div>
        <div class='btnNavi home' @click="appMoveMain()">
          <div class="ico">홈</div>
        </div>
      </div>
    </header>
    <!-- <div class="orderHistoryHeader">
      <h1 class="orderHistoryTitle">주문 내역</h1>
    </div> -->
    <!-- <div class="orderHistoryTabs">
      <div v-for="(tab, index) in tabs" :key="index" :class="{ 'active': activeTab === index }" @click="activeTab = index">
        {{ $i18n.locale == 'ko' ? tab.nameKo : $i18n.locale == 'en' ? tab.nameEn : tab.nameCn }}
      </div>
    </div> -->
    <Loading v-if="getLoading"/>
    <div class="orderHistoryTabContent" v-else-if="historyLength > 0">
      <div v-for="(order, index) in orderHistories" :key="index" class="TabContentWrap">
        <div class="franchisee" @click="storeIntroUrl(order)">
          {{order.name}}
        </div>
        <div class="orderTime">{{ order.time }}</div>
        <div class="menuList">{{ order.repMenuName }}
          <span v-if='order.orderMenuCount > 1'> 외
            <strong class='emphasis'> {{order.orderMenuCount - 1}}건</strong>
          </span>
        </div>
        <div class="amountBox">
          <div class="amountCancel" v-if="order.orderProgressFlag==4">
            <span class="amountTag2">주문취소</span>
            <div class="cancelTag">
              <span>{{formatComma(order.price)}}</span>원
            </div>
          </div>
          <div v-else>
            <div class="normalTag">
              <span>{{formatComma(order.price)}}</span>원
            </div>
            <div>
              <span class="amountTag1" v-if="order.qrType == 1">{{$t('orderForDelivery')}}</span>
              <span class="amountTag1" v-else-if="order.qrType == 0">{{$t('orderInStore')}}</span>
              <span class="amountTag1" v-if="order.packingFlag==0">{{$t('inStore')}}</span>
              <span class="amountTag1" v-else-if="order.packingFlag==1">{{$t('takeOut')}}</span>
              <span class="amountTag1" v-else-if="order.packingFlag==2 && companyType === 5">배송</span>
              <span class="amountTag1" v-else-if="order.packingFlag==2">{{$t('delivery')}}</span>
              <span v-else-if="order.packingFlag==''"></span>
            </div>
          </div>
        </div>
        <div class="pickupBox" v-if="pickupBoxFlag(order)">
          <div class="pickupBoxWrap">
            <div class="pickupMenu">{{ order.repMenuName }}</div>
            <div class="pickupNo">
              <h2>알림번호</h2>
              <span>{{ order.notificationNo }}</span>
            </div>
          </div>
        </div>
        <div class="showOrderHistoryWrap">
          <div class="showOrderHistory" @click="orderListDetail(order)">
            주문내역 보기
          </div>
        </div>
      </div>
    </div>
    <div class="noMenu noOrder" v-else>
      <img src="../assets/img/ic_error_36.png" >
      <p>{{$t(`MyPage.noOrderHistory`)}}</p>
    </div>
    <OrderDetailPopUp :appOrder="appOrder"/>
  </div>
</template>

<script lang="js">
import OrderDetailPopUp from '@/components/PopUp/OrderDetailPopUp.vue'
import { NETWORK_ERROR_MESSAGE } from '@/utils/Message'
import service from '@/backend/modnpay_app_api'
import OrderDetailMixin from '@/utils/OrderDetailMixin'
import Loading from '@/components/Common/Loading.vue'

export default {
  components: { OrderDetailPopUp, Loading },
  mixins: [OrderDetailMixin],
  data () {
    return {
      activeTab: 0,
      tabs: [
        {
          nameKo: '전체',
          nameEn: 'All',
          nameCn: '全部',
          historyFlag: 1
        },
        {
          nameKo: '음식',
          nameEn: 'Food',
          nameCn: '食物',
          historyFlag: 2
        },
        {
          nameKo: '쇼핑',
          nameEn: 'Shopping',
          nameCn: '购物',
          historyFlag: 3
        }
      ],
      orderHistories: [],
      companyType: this.$store.getters.companyType,
      deviceId: '',
      modalToggle: false
    }
  },
  computed: {
    historyLength () { return this.orderHistories ? this.orderHistories.length : 0 },
    getLoading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    activeTab () { this.orderList() }
  },
  created () {
    this.orderList()
  },
  updated () {
    sessionStorage.getItem('langType')
      ? this.$i18n.locale = sessionStorage.getItem('langType')
      : this.$i18n.locale = this.$store.getters.langType
  },
  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
    this.deviceId = JSON.parse(sessionStorage.getItem('deviceId'))
  },
  methods: {
    backBtn () {
      const currentURL = window.location.href // URLSearchParams 객체 생성
      const params = new URLSearchParams(new URL(currentURL).search) // 파라미터 추출
      if (params.get('isPayment') === 'true' || this.isBillHistory) {
        this.appMoveMain()
      } else {
        history.back()
      }
    },
    async storeIntroUrl (order) {
      const req = {
        urlCode: order.StoreGroupCode,
        introUrlType: order.qrType
      }
      const { data } = await service.storeIntroUrl(req)
      sessionStorage.removeItem('tradition')
      sessionStorage.removeItem('categoryCode')
      sessionStorage.removeItem('addressByLotNum')
      sessionStorage.removeItem('time')
      window.location.href = data.introUrl
    },
    async orderList () {
      const req = {
        pageNumber: this.pageNumber,
        deviceId: this.deviceId,
        orderSearchType: this.activeTab
      }
      const { data } = await service.orderList(req)
      if (data.resultCode === 0) {
        if (data.beforeWeek && !this.isUser) {
          this.modalToggle = true
        }
        this.orderHistories = data.orderList
        this.checkAndShowOrder()
      } else if (data.resultCode === 21) {
        this.orderHistories = []
      }
    },
    pickupBoxFlag (order) {
      if (order.orderProgressFlag !== 4 && (order.packingFlag === 1 || order.packingFlag === 0)) {
        return true
      }
      return false
    },
    requestOrderDetail (orderCode) {
      this.$store.dispatch('reqOrderDetail', orderCode)
        .then(() => {
          this.createPopUp('#orderDetailList.cusLayer')
        })
        .catch(() => this.toast(this, NETWORK_ERROR_MESSAGE))
    },
    modalSignCancel () { // 회원가입 취소
      this.modalToggle = false
    },
    modalSignCheck () { // 회원가입 이동
      this.$router.push({ name: 'AppLogin' })
    }
  }
}
</script>

<style scoped>
</style>
